import PrimiSeal from "./assets/seal.webp"

export type SealMaskProps = { serial: string; className?: string; publicHash: string }

export function SealMask({ serial, publicHash, className }: SealMaskProps) {
	return (
		<div className={`relative inline-block w-full max-w-md ${className ?? ""}`}>
			<img src={PrimiSeal} alt="Imagem do selo Primi" className="block h-auto w-full" />
			<div className="absolute left-[5%] top-[2%] rounded-sm bg-black/50 px-[3%] py-[0.5%]">
				<p className="font-[Doto] text-[clamp(0.75rem,4vw,1.5rem)] font-bold leading-tight text-white">{serial}</p>
			</div>

			<div className="absolute right-[4%] top-[18%] rounded-sm px-[3%] py-[0.5%] text-[#6a6768]">
				<p className="text-center text-[clamp(0.875rem,5vw,1.75rem)] leading-tight">{publicHash}</p>
			</div>
		</div>
	)
}
